// @flow
import {
  DETECT_IMAGE,
  SAVE_TOKEN,
  SET_CANVAS_STATE_FACES,
  SET_LOADED_IMAGE,
  GET_ALL_TAGS,
  ADD_IMAGE_TO_FACE_SEARCH,
  SEARCH_BY_FACE,
  SET_SEARCHED_PERSON,
  SET_CURRENT_FACE
} from "../../global/actions/actionNames";

import { FaceDetectionResultType } from "../../global/types/FaceType";

export type FaceSearchStateType = {
  imgToken?: string,
  detectedFaces: FaceDetectionResultType[],
  minimalCanvasState: *,
  loadedImage: *,
  tags?: string[],
  faceSearchImage: *,
  faceSearchResult: *,
  searchedPerson: *
};

const initialState: FaceSearchStateType = {
  imgToken: undefined,
  detectedFaces: undefined,
  minimalCanvasState: undefined,
  loadedImage: undefined,
  tags: undefined,
  faceSearchImage: undefined,
  faceSearchResult: {},
  searchedPerson: undefined
};

const faceSearchReducer = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case SAVE_TOKEN:
      if (actions.token !== undefined) {
        return {
          ...state,
          imgToken: actions.token
        };
      } else {
        return {
          ...state,
          imgToken: undefined
        };
      }
    case DETECT_IMAGE:
      if (actions.detectedFaces !== undefined) {
        return {
          ...state,
          detectedFaces: actions.detectedFaces
        };
      } else {
        return {
          ...state,
          detectedFaces: undefined
        };
      }
    case SET_CANVAS_STATE_FACES:
      if (actions.minimalCanvasState !== undefined) {
        return {
          ...state,
          minimalCanvasState: actions.minimalCanvasState
        };
      }
      return state;
    case SET_LOADED_IMAGE:
      if (actions.data !== undefined) {
        return {
          ...state,
          loadedImage: actions.data
        };
      }
      return state;

    case ADD_IMAGE_TO_FACE_SEARCH:
      if (actions.data !== undefined) {
        return {
          ...state,
          faceSearchImage: actions.data
        };
      }
      return state;
    case SEARCH_BY_FACE:
      if (actions.faceSearchResult !== undefined) {
        return {
          ...state,
          faceSearchResult: actions.faceSearchResult
        };
      } else {
        return {
          ...state,
          faceSearchResult: undefined
        };
      }
    case SET_SEARCHED_PERSON:
      if (actions.searchedPerson !== undefined) {
        return {
          ...state,
          searchedPerson: actions.searchedPerson
        };
      } else {
        return {
          ...state,
          searchedPerson: undefined
        };
      }
    case SET_CURRENT_FACE:
      if (actions.face !== undefined) {
        return {
          ...state,
          currentFace: actions.face
        };
      } else {
        return {
          ...state,
          currentFace: undefined
        };
      }
    default:
      return state;
  }
};

export default faceSearchReducer;
